// /dagontvangsten – scherm van de KASSIER. Alleen de EIGEN winkel.
// Tabs: Z-tickets (alle dagen) · PDF dagontvangsten (controle) · Centralisatieboek (popup).
// Het scherm "Dagontvangsten vandaag" is bewust VERWIJDERD: de kassier ziet geen lopende dagcijfers.
import { useEffect, useState } from "react";
import { api, foutTekst, vandaagISO } from "../api";
import { CentralisatiePopup, Kop } from "../components/Onderdelen";
import PdfArchief from "../components/PdfArchief";
import ZTickets from "../components/ZTickets";

const maandStart = () => vandaagISO().slice(0, 8) + "01";

export default function DagontvangstenVandaag({ onAfmelden }) {
  const [tab, setTab] = useState("z");
  const [popup, setPopup] = useState(false);
  const [me, setMe] = useState(null);
  const [fout, setFout] = useState("");
  const [van, setVan] = useState(maandStart());
  const [tot, setTot] = useState(vandaagISO());

  useEffect(() => {
    api.get("/me").then((r) => { setMe(r.data); setFout(""); }).catch((e) => setFout(foutTekst(e)));
  }, []);

  const v = me?.vestiging;
  const tarieven = me?.tarieven || [];

  const Tab = ({ id, children }) => (
    <button onClick={() => (id === "centr" ? setPopup(true) : setTab(id))}
      className={`px-4 py-2.5 rounded-xl text-sm font-semibold border ${tab === id ? "bg-blue-600 text-white border-blue-600" : "bg-white text-slate-600 border-slate-200"}`}>
      {children}
    </button>
  );

  return (
    <div className="min-h-screen bg-[#f1f4f9]">
      <Kop titel="Digitale dagontvangsten" sub={tab === "z" ? "Opgeslagen Z-tickets" : v ? `${v.naam}${v.adres ? ` · ${v.adres}` : ""}` : ""} onAfmelden={onAfmelden} />
      <div className="px-5 pt-3 flex gap-2 flex-wrap items-center">
        <Tab id="z">🧾 Z-tickets</Tab>
        <Tab id="pdf">📄 PDF dagontvangsten (controle)</Tab>
        <Tab id="centr">🏢 Centralisatieboek</Tab>
        {v && <span className="ml-auto px-4 py-2.5 rounded-xl text-sm font-semibold bg-[#1e2a44] text-white">{v.korte_naam}</span>}
      </div>
      {fout && <div className="mx-5 mt-3 p-3 rounded-xl bg-red-50 text-red-700 text-sm">{fout}</div>}

      {tab === "z" && <ZTickets tarieven={tarieven} />}

      {tab === "pdf" && (
        <PdfArchief vestiging={v} van={van} tot={tot} periodeKiezer={
          <span className="flex items-center gap-1 text-sm">📅
            <input type="date" value={van} max={tot} onChange={(e) => e.target.value && setVan(e.target.value)} className="border rounded-lg px-2 py-1.5" />–
            <input type="date" value={tot} min={van} max={vandaagISO()} onChange={(e) => e.target.value && setTot(e.target.value)} className="border rounded-lg px-2 py-1.5" />
          </span>} />
      )}

      {popup && <CentralisatiePopup onSluit={() => setPopup(false)} />}
    </div>
  );
}
